module.exports = __webpack_public_path__ + "static/media/club.4e4cb59f.svg";